export const tableParentOptions = {
  teamMembers: 'TeamMembersList.jsx',
  playerProfiles: 'PlayerProfilesList.jsx',
  groups: 'GroupsList.jsx'
};
